// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat Input Text */

.help-desk-conversation-wrapper .help-desk-send-message-animation {
  opacity: 1;
  transform: translateY(0px);
  animation-name: mymove;
  animation-duration: 320ms;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-delay: 80ms;
  animation-fill-mode: both;
}

@keyframes mymove {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.help-desk-send-message-container {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  border-radius: 0px 0px 6px 6px;
}

  .help-desk-composer {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    min-height: 56px;
    border-top: 1px solid rgb(230, 230, 230);
  }

    .help-desk-composer pre {
      visibility: hidden;
    }

    .help-desk-composer textarea, .help-desk-composer pre {
      margin-top: 0px;
      margin-bottom: 0px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.33;
      background-color: rgb(255, 255, 255);
      white-space: pre-wrap;
      overflow-wrap: break-word;
      padding: 18px 100px 18px 29px;
    }


    .help-desk-composer textarea {
      position: absolute;
      bottom: 0px;
      left: 0px;
      color: rgb(0, 0, 0);
      resize: none;
      outline-offset: -5px;
      border-width: initial;
      border-style: none;
      border-color: initial;
      border-image: initial;
      transition: background-color 200ms ease 0s, box-shadow 200ms ease 0s;
  }
  
  .help-desk-composer textarea, .help-desk-composer pre {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.33;
      background-color: rgb(255, 255, 255);
      white-space: pre-wrap;
      overflow-wrap: break-word;
      padding: 18px 100px 18px 29px;
  }
  
  textarea, input {
      cursor: text;
  }

.help-desk-composer-buttons {
  position: absolute;
  top: 0px;
  right: 21px;
}

.help-desk-composer-gif-button:hover {
  opacity: 1;
}

.help-desk-composer-gif-button {
  position: relative;
  float: left;
  display: inline-block;
  cursor: pointer;
  opacity: 0.8;
  height: 51px;
  margin-top: 2px;
  width: 29px;
  padding-left: 8px;
  padding-right: 8px;
  transition: opacity 200ms ease 0s;
}

.help-desk-composer-upload-button:hover, .help-desk-composer-emoji-button:hover {
  opacity: 1;
}

.help-desk-composer-upload-button, .help-desk-composer-emoji-button {
  position: relative;
  float: left;
  display: inline-block;
  cursor: pointer;
  opacity: 0.8;
  height: 51px;
  margin-top: 2px;
  width: 18px;
  padding-left: 8px;
  padding-right: 8px;
  transition: opacity 200ms ease 0s;
}

.help-desk-composer-gif-button svg {
  height: 18px;
}

.help-desk-composer-gif-button svg {
  position: absolute;
  top: 18px;
}

.help-desk-composer-gif-button svg path {
  fill: rgb(115, 115, 118);
}

.help-desk-composer-upload-button svg, .help-desk-composer-emoji-button svg {
  height: 18px;
  width: 18px;
}

.help-desk-composer-upload-button svg, .help-desk-composer-emoji-button svg {
  position: absolute;
  top: 18px;
}

.help-desk-composer-upload-button svg path, .help-desk-composer-emoji-button svg path {
  fill: rgb(115, 115, 118);
}

.help-desk-composer-send-button {
  position: relative;
  display: inline-block;
  cursor: pointer;
  opacity: 0.8;
  height: 51px;
  margin-top: 2px;
  width: 15px;
  padding-left: 8px;
  padding-right: 8px;
  top: 1px;
  transition: opacity 200ms ease 0s;
}

.help-desk-composer-send-button:disabled {
  opacity: 0.5;
}

.help-desk-composer-send-button svg {
  height: 16px;
  width: 15px;
}

.help-desk-composer-send-button svg {
  position: absolute;
  top: 18px;
}

.help-desk-composer-send-button svg path {
  fill: rgb(115, 115, 118);
}
`, "",{"version":3,"sources":["webpack://./dist/src/components/controls/send-message/send-message.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,yDAAyD;EACzD,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;EAEE;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,wCAAwC;EAC1C;;IAEE;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,yCAAyC;MACzC,eAAe;MACf,mBAAmB;MACnB,iBAAiB;MACjB,oCAAoC;MACpC,qBAAqB;MACrB,yBAAyB;MACzB,6BAA6B;IAC/B;;;IAGA;MACE,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,mBAAmB;MACnB,YAAY;MACZ,oBAAoB;MACpB,qBAAqB;MACrB,kBAAkB;MAClB,qBAAqB;MACrB,qBAAqB;MACrB,oEAAoE;EACxE;;EAEA;MACI,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,yCAAyC;MACzC,eAAe;MACf,mBAAmB;MACnB,iBAAiB;MACjB,oCAAoC;MACpC,qBAAqB;MACrB,yBAAyB;MACzB,6BAA6B;EACjC;;EAEA;MACI,YAAY;EAChB;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Chat Input Text */\r\n\r\n.help-desk-conversation-wrapper .help-desk-send-message-animation {\r\n  opacity: 1;\r\n  transform: translateY(0px);\r\n  animation-name: mymove;\r\n  animation-duration: 320ms;\r\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n  animation-delay: 80ms;\r\n  animation-fill-mode: both;\r\n}\r\n\r\n@keyframes mymove {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(15px);\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n.help-desk-send-message-container {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  border-radius: 0px 0px 6px 6px;\r\n}\r\n\r\n  .help-desk-composer {\r\n    position: absolute;\r\n    bottom: 0px;\r\n    left: 0px;\r\n    right: 0px;\r\n    min-height: 56px;\r\n    border-top: 1px solid rgb(230, 230, 230);\r\n  }\r\n\r\n    .help-desk-composer pre {\r\n      visibility: hidden;\r\n    }\r\n\r\n    .help-desk-composer textarea, .help-desk-composer pre {\r\n      margin-top: 0px;\r\n      margin-bottom: 0px;\r\n      box-sizing: border-box;\r\n      width: 100%;\r\n      height: 100%;\r\n      font-family: Helvetica, Arial, sans-serif;\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n      line-height: 1.33;\r\n      background-color: rgb(255, 255, 255);\r\n      white-space: pre-wrap;\r\n      overflow-wrap: break-word;\r\n      padding: 18px 100px 18px 29px;\r\n    }\r\n\r\n\r\n    .help-desk-composer textarea {\r\n      position: absolute;\r\n      bottom: 0px;\r\n      left: 0px;\r\n      color: rgb(0, 0, 0);\r\n      resize: none;\r\n      outline-offset: -5px;\r\n      border-width: initial;\r\n      border-style: none;\r\n      border-color: initial;\r\n      border-image: initial;\r\n      transition: background-color 200ms ease 0s, box-shadow 200ms ease 0s;\r\n  }\r\n  \r\n  .help-desk-composer textarea, .help-desk-composer pre {\r\n      box-sizing: border-box;\r\n      width: 100%;\r\n      height: 100%;\r\n      font-family: Helvetica, Arial, sans-serif;\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n      line-height: 1.33;\r\n      background-color: rgb(255, 255, 255);\r\n      white-space: pre-wrap;\r\n      overflow-wrap: break-word;\r\n      padding: 18px 100px 18px 29px;\r\n  }\r\n  \r\n  textarea, input {\r\n      cursor: text;\r\n  }\r\n\r\n.help-desk-composer-buttons {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 21px;\r\n}\r\n\r\n.help-desk-composer-gif-button:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.help-desk-composer-gif-button {\r\n  position: relative;\r\n  float: left;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  opacity: 0.8;\r\n  height: 51px;\r\n  margin-top: 2px;\r\n  width: 29px;\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  transition: opacity 200ms ease 0s;\r\n}\r\n\r\n.help-desk-composer-upload-button:hover, .help-desk-composer-emoji-button:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.help-desk-composer-upload-button, .help-desk-composer-emoji-button {\r\n  position: relative;\r\n  float: left;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  opacity: 0.8;\r\n  height: 51px;\r\n  margin-top: 2px;\r\n  width: 18px;\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  transition: opacity 200ms ease 0s;\r\n}\r\n\r\n.help-desk-composer-gif-button svg {\r\n  height: 18px;\r\n}\r\n\r\n.help-desk-composer-gif-button svg {\r\n  position: absolute;\r\n  top: 18px;\r\n}\r\n\r\n.help-desk-composer-gif-button svg path {\r\n  fill: rgb(115, 115, 118);\r\n}\r\n\r\n.help-desk-composer-upload-button svg, .help-desk-composer-emoji-button svg {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n\r\n.help-desk-composer-upload-button svg, .help-desk-composer-emoji-button svg {\r\n  position: absolute;\r\n  top: 18px;\r\n}\r\n\r\n.help-desk-composer-upload-button svg path, .help-desk-composer-emoji-button svg path {\r\n  fill: rgb(115, 115, 118);\r\n}\r\n\r\n.help-desk-composer-send-button {\r\n  position: relative;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  opacity: 0.8;\r\n  height: 51px;\r\n  margin-top: 2px;\r\n  width: 15px;\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  top: 1px;\r\n  transition: opacity 200ms ease 0s;\r\n}\r\n\r\n.help-desk-composer-send-button:disabled {\r\n  opacity: 0.5;\r\n}\r\n\r\n.help-desk-composer-send-button svg {\r\n  height: 16px;\r\n  width: 15px;\r\n}\r\n\r\n.help-desk-composer-send-button svg {\r\n  position: absolute;\r\n  top: 18px;\r\n}\r\n\r\n.help-desk-composer-send-button svg path {\r\n  fill: rgb(115, 115, 118);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
